import { Stack, Box } from "@mui/material";
import { FC } from "react";
import SalifyTypography from "../../typography/default";
import SalifySvgIconString from "../../icon/svg/svg-icon-string";
import { ContentBlock as ContentBlockType } from "../types";

interface ContentBlockProps {
  content: ContentBlockType;
  theme: string;
}

const ContentBlock: FC<ContentBlockProps> = ({ content, theme }) => {
  const getThemeStyles = () => {
    switch (theme) {
      case "haianh":
        return {
          description: {
            fontSize: 14,
            lineHeight: 1.6,
            color: "#666",
            fontWeight: 400,
          },
          bulletPoint: {
            fontSize: 14,
            lineHeight: 1.5,
            color: "#555",
          },
        };
      case "nova-press":
        return {
          description: {
            fontSize: 15,
            lineHeight: 1.6,
            color: "#666",
          },
          bulletPoint: {
            fontSize: 14,
            lineHeight: 1.5,
            color: "#555",
          },
        };
      default:
        return {
          description: {
            fontSize: 16,
            lineHeight: 1.6,
            color: "#666",
            fontWeight: 400,
          },
          bulletPoint: {
            fontSize: 13,
            lineHeight: 1.5,
            color: "#555",
          },
        };
    }
  };

  const themeStyles = getThemeStyles();

  return (
    <Stack spacing={2} alignItems="flex-start" {...content.stackProps}>
      {content.description?.text && (
        <SalifyTypography
          text={content.description.text}
          cssProps={{
            ...themeStyles.description,
            ...content.description.cssProps,
          }}
        />
      )}

      {content.bulletPoints && content.bulletPoints.length > 0 && (
        <Stack spacing={1}>
          {content.bulletPoints.map((point, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 1,
              }}
            >
              {point.icon ? (
                <SalifySvgIconString svgString={point.icon} fontSize={16} />
              ) : (
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    backgroundColor: theme === "haianh" ? "#FFC107" : "#666",
                    marginTop: 0.8,
                    flexShrink: 0,
                  }}
                />
              )}
              <SalifyTypography
                text={point.text}
                cssProps={{
                  ...themeStyles.bulletPoint,
                  ...point.cssProps,
                }}
              />
            </Box>
          ))}
        </Stack>
      )}
    </Stack>
  );
};

export default ContentBlock;
